import React, { useState } from 'react';
import PricingSettings from '../components/Settings/PricingSettings';
import { useAuth } from '../contexts/AuthContext';
import './SettingsPage.css';

/**
 * Presets page that contains various settings sections
 */
const SettingsPage = () => {
  const { user } = useAuth();
  const [activeTab, setActiveTab] = useState('pricing');

  // If not authenticated, show message
  if (!user) {
    return (
      <div className="settings-page">
        <div className="settings-content-full">
          <div className="settings-auth-message">
            <h2>Presets</h2>
            <p>Please log in to access presets.</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="settings-page">
      <div className="settings-content-full">
        <PricingSettings />
      </div>
    </div>
  );
};

export default SettingsPage; 